import { Dialog } from 'primereact/dialog';
import { FC } from 'react';
import { OtherLearningResources } from '../OtherLearningResources/OtherLearningResources';

interface Props {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  lesson: {
    id: string;
    name: string;
    summary: string;
    url: string;
  };
}

export const AlignedContentModal: FC<Props> = ({ visible, setVisible, lesson }) => {
  return (
    <Dialog className="w-full" visible={visible} onHide={() => setVisible(false)}>
      <OtherLearningResources lesson={lesson} />
    </Dialog>
  );
};
